import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store'; // Adjust if your RootState import path is different

interface ChatState {
  llmStreamingJustEnded: boolean;
  // Add other chat-related state properties here if needed in the future
}

const initialState: ChatState = {
  llmStreamingJustEnded: false,
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setLlmStreamingEnded: (state, action: PayloadAction<boolean>) => {
      state.llmStreamingJustEnded = action.payload;
    },
  },
});

export const { setLlmStreamingEnded } = chatSlice.actions;

// Selector to get this state
export const selectLlmStreamingJustEnded = (state: RootState) =>
  state.chat.llmStreamingJustEnded;

export default chatSlice.reducer;
